import React from 'react';
import { IconSolidEnvelope } from './Icons';

interface EmailLabelProps {
  email?: string | null;
}

/**
 * Renders email address as a clickable mailto link with envelope icon.
 */
export default function EmailLabel({ email }: EmailLabelProps) {
  if (!email) {
    return null;
  }

  return (
    <a href={`mailto:${email}`}>
      <IconSolidEnvelope className="mr-2" />
      {email}
    </a>
  );
}
